import { SortItem } from "@models/ss-api/responses/member.dashboard.license.response";
import { ISortable } from '../../helpers/sort';

export class BubbleItemArray extends Array<BubbleItem> implements ISortable {

    public LastSort = new SortItem;

    constructor(...items: BubbleItem[]) {
        super(...items);
        Object.setPrototypeOf(this, BubbleItemArray.prototype);
    }

    static FixDates(items: BubbleItemArray) {
        items.forEach(x => BubbleItem.FixDate(x));
    }    

}

export class BubbleItem  {
    BubbleItemID: number;    
    Title: string;
    Description: string;
    Enabled: boolean;
    LinkURL: string;    
    SortOrder: number;
    StartDate: Date;
    ExpirationDate: Date;    
    BubbleGroupName: string;
    BubbleGroupID: number;
    MinimumSoftwareVersionInt: number;
    MaximumSoftwareVersionInt: number;
    BubbleColor: string;
    BubbleIcon: string;

    static FixDate(item: BubbleItem) {
        item.StartDate = new Date(item.StartDate);
        item.ExpirationDate = new Date(item.ExpirationDate);
    } 
}
